"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILCalendarProvider = exports.ILCalendarContext = void 0;
var react_1 = __importDefault(require("react"));
var date_fns_1 = require("date-fns");
var ILCalendarContext = react_1.default.createContext({});
exports.ILCalendarContext = ILCalendarContext;
var functionSelector = {
    DAY: date_fns_1.addDays,
    WEEK: date_fns_1.addWeeks,
    MONTH: date_fns_1.addMonths,
};
function ILCalendarProvider(_a) {
    var children = _a.children, defaultContext = _a.defaultContext;
    var _b = react_1.default.useState((defaultContext === null || defaultContext === void 0 ? void 0 : defaultContext.calendarType) || 'WEEK'), calendarType = _b[0], setCalendarType = _b[1];
    var _c = react_1.default.useState((defaultContext === null || defaultContext === void 0 ? void 0 : defaultContext.selectedDate) || new Date()), selectedDate = _c[0], setSelectedDate = _c[1];
    function increaseDate(amount) {
        if (amount === void 0) { amount = 1; }
        setSelectedDate(functionSelector[calendarType](selectedDate, amount));
    }
    function decreaseDate(amount) {
        if (amount === void 0) { amount = -1; }
        setSelectedDate(functionSelector[calendarType](selectedDate, amount));
    }
    return (react_1.default.createElement(ILCalendarContext.Provider, { value: {
            calendarType: calendarType,
            changeCalendarType: setCalendarType,
            selectedDate: selectedDate,
            changeSelectedDate: setSelectedDate,
            increaseDate: increaseDate,
            decreaseDate: decreaseDate,
        } }, children));
}
exports.ILCalendarProvider = ILCalendarProvider;
